import React, { useContext } from "react";
import { ReactComponent as DocumentIcon } from "assets/img/svg/Document.svg";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard.jsx";
import { useHistory } from "react-router";

const CustomConcessionConfig = () => {
  const history = useHistory();

  const screens = [
    {
      heading: "Custom concession for regular charges",
      subHeading: "For 1Y, 2Y, 3Y, 4Y regular courses",
      icon: <DocumentIcon />,
      action: () =>
        history.push(`/admin/master/custom-concession/regular-charges`),
    },
    {
      heading: "Custom concession for others",
      subHeading:
        "For misc courses like Security deposit, Cheque bounce and etc",
      icon: <DocumentIcon />,
      action: () =>
        history.push(`/admin/master/custom-concession/otherCharges-charges`),
    },
        {
      heading: "ARPU Master Setup",
      subHeading: "To configure the ARPU of the Branches",
      icon: <DocumentIcon />,
      action: () =>
        history.push(`/admin/master/custom-concession/arpu`),
    },
  ];
  return (
    <div className={`screen-cards-container`}>
      {getScreenCards(screens?.filter((item) => item))}
    </div>
  );
};

export default CustomConcessionConfig;
